import React from "react";

import "../../../ChatStyle.less";
import { ChatContextData, useChat } from "../../../../../../../context/ChatContext/ChatContext";
import { useSelector, DefaultRootState } from "react-redux";
import { ChatRoomInterface, ChatUserInterface } from "../../../ChatInterfaces";
import { removeNameFromTitle } from "../../../ChatScripts";
import clsx from "clsx";

type ListType = "Messages" | "Contact" | "Bot";

interface ChatRoomListItemProps {
   listType: ListType;
   room?: ChatRoomInterface;
   user?: ChatUserInterface;
   onClick: (room: any) => void;
   selectedRoom: string;
}
const ChatRoomListItem: React.FC<ChatRoomListItemProps> = ({
   listType = "Messages",
   room,
   user,
   onClick,
   selectedRoom,
}) => {
   const { oldId, firstName } = useSelector((state: DefaultRootState) => state.user);
   const { avatars } = useSelector(({ companies }: any) => companies);

   if (listType === "Messages") {
      const userImage: string | undefined = avatars?.find(
         ({ userOldId }) => userOldId === room?.chatUsers?.find((user) => user !== oldId),
      )?.avatarUrl;

      const roomImage: string | undefined = avatars?.find(({ userOldId }) => {
         const userToCompare =
            typeof room?.chatUsers[0] === "string" ? room?.chatUsers[1] : room?.chatUsers[0];
         return userOldId === userToCompare;
      })?.avatarUrl;
      // TODO: make 2 icons as a group chat avatar

      return (
         <div onClick={() => onClick(room)} className="chat-room-list-item">
            {room?.type === "direct" ? (
               userImage !== undefined ? (
                  <img className="chat-room-list-item__image" src={userImage} />
               ) : (
                  <span style={{ fontSize: "36px" }} className="material-symbols-outlined">
                     account_circle
                  </span>
               )
            ) : roomImage ? (
               <span style={{ fontSize: "36px" }} className="material-symbols-outlined">
                  group
               </span>
            ) : (
               // <img className="chat-room-list-item__image" src={roomImage} />
               <span style={{ fontSize: "36px" }} className="material-symbols-outlined">
                  account_circle
               </span>
            )}
            <div className="chat-room-list-item__text-container">
               <span
                  title={room?.title}
                  className={clsx({
                     "selected-title": selectedRoom === room?.id,
                     "new-message-title": !room?.seenBy?.includes(oldId),
                     title: selectedRoom !== room?.id && room?.seenBy?.includes(oldId),
                  })}
               >
                  {room?.type === "direct"
                     ? removeNameFromTitle(room?.title, firstName)
                     : room?.title}
               </span>
               <span title={room?.subTitle} className="subtitle">
                  {room?.subTitle}
               </span>
            </div>
            {!room?.seenBy?.includes(oldId) && (
               <div className="chat-room-list-item__new-message-notyfication"></div>
            )}
         </div>
      );
   }

   if (listType === "Contact") {
      const userImage: string | undefined = avatars?.find(
         ({ userOldId }) => userOldId === user?.oldId,
      )?.avatarUrl;

      return (
         <div onClick={() => onClick(user)} className="chat-room-list-item">
            {userImage === undefined ? (
               <span style={{ fontSize: "36px" }} className="material-symbols-outlined">
                  account_circle
               </span>
            ) : (
               <img className="chat-room-list-item__image" src={userImage} />
            )}
            <div className="chat-room-list-item__text-container">
               <span title={user?.firstName + " " + user?.lastName} className="title">
                  {user?.firstName + " " + user?.lastName}
               </span>
            </div>
         </div>
      );
   }

   return null;
};

export default ChatRoomListItem;
